import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import ReactEcharts from 'echarts-for-react';
import { getStyleT } from '../charts.js';
import './Factors.css';
import i18n from '../../../i18n.js';

const Factors = () => {
  const chartRef = useRef(null);
  const data = useSelector((state) => state.fundData.data);

  // Filter out funds with styleBoxPlotPoints
  const styleBoxData = data.filter(
    (x) => x.styleBoxPlotPoints && x.styleBoxPlotPoints.length > 0
  );

  // Highlight/unhighlight logic
  const updateHighlight = (ticker, highlight = true) => {
    const chartInstance = chartRef.current?.getEchartsInstance?.();
    if (!chartInstance) return;

    const newRadius = highlight ? 10 : 6;
    const newStyle = highlight
      ? { lineWidth: 2, stroke: 'gold' }
      : { lineWidth: 1, stroke: null };

    chartInstance.setOption({
      graphic: [
        { id: `growth-${ticker}`, shape: { r: newRadius }, style: newStyle },
        { id: `size-${ticker}`, shape: { r: newRadius }, style: newStyle },
      ],
    });
  };

  // Compute "as of" date
  const getAsOfDate = () => {
    const fund = styleBoxData[0];
    const points = fund.styleBoxPlotPoints;
    if (points && points.length && points[points.length - 1].date) {
      return new Date(points[points.length - 1].date)
        .toLocaleDateString()
        .split(',')[0];
    }
    return new Date().toLocaleDateString().split(',')[0];
  };

  return (
    <div className="fund-char-factors">
      {styleBoxData.length > 0 ? (
        <>
          {/* Chart header with bottom margin */}
          <div
            className="factors-chart-header"
            style={{ marginBottom: '20px' }}
          >
            <span className="factors-chart-title">{i18n.t('EXPOSURE T')}</span>{' '}
            {i18n.t('as of')} {getAsOfDate()}
          </div>

          {/* Centered chart container */}
          <div
            className="chartContainer"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '65px',
            }}
          >
            <ReactEcharts
              ref={chartRef}
              option={getStyleT(styleBoxData, updateHighlight)}
              notMerge={true}
              style={{ width: 600, height: 600 }}
            />
          </div>

          {/* Definition centered below chart with spacing */}
          <div
            className="factorCompliance"
            style={{
              textAlign: 'left',
              marginTop: '20px',
              marginBottom: '40px',
            }}
          >
            {i18n.t('factors_grid')}
          </div>
        </>
      ) : (
        <div
          className="noData"
          style={{ textAlign: 'left', marginTop: '65px' }}
        >
          {i18n.t('no-data')}
        </div>
      )}
    </div>
  );
};

export default Factors;
